<template>
    <div class="px-3 py-4 h-100" role="tablist">
        <b-form-group v-if="standaloneMode">
            <b-form-radio-group
                id="btn-radios-1"
                v-model="activeStep"
                :options="steps"
                name="radios-btn-default"
                buttons
            ></b-form-radio-group>
        </b-form-group>
        <div class="mb-1 d-flex flex-column justify-content-between align-items-between h-100" v-if="activeStep == 0">
            <div class="bg-gris-pro rounded-10 pb-3">
                <span class="bg-rose rounded-top-10 d-block py-2 text-center font-weight-bold text-white mb-3"><t blueprintSidebar.errors /></span>

                <!-- <div v-if="colors.length > 1" class="mx-3 py-3 bg-white rounded-10">
                    <div class="px-3">
                        <h5>Couleurs des traits du fichier DXF.</h5>
                        <span class="d-block mb-2">Cliquez sur une couleur pour ignorer ces traits.</span>
                    </div>
                    <div class="px-3">
                        <b-button class="rounded-circle py-0 px-1" v-for="color in this.colors" v-bind:key="color.rgb" @click="switchColor(color.rgb)" :pressed="color.selected" variant="outline">
                            <b-iconstack font-scale="4">
                                <b-icon class="rounded-circle" stacked icon="square-fill" :style="'color:' + color.rgb + ' !important;'" />
                                <b-icon stacked v-if="!color.selected" icon="circle-fill" shift-v="-4" shift-h="4" scale="0.5" variant="dark" />
                                <b-icon stacked v-if="!color.selected" icon="circle-fill" shift-v="-4" shift-h="4" scale="0.48" variant="light" />
                                <b-icon stacked v-if="!color.selected" icon="slash-circle" shift-v="-4" shift-h="4" scale="0.4" variant="dark" />
                            </b-iconstack>
                        </b-button>
                    </div>
                </div> -->
                <div v-if="cleaningReport.nbItems == 0 && standaloneMode" class="bg-white rounded-10 p-3 mx-3 mt-3">
                    <t blueprintSidebar.lineToSelect />
                </div>
                <div v-if="crossingPoints.length > 0">
                    <div class="bg-white rounded-10 p-3 mx-3 mt-3 position-relative">
                        <h5><t blueprintSidebar.crossingTitle /></h5>
                        <span><t blueprintSidebar.crossingText /></span>
                        <div class="error-detect intersection"><t blueprintSidebar.tooManyCrossing /></div>
                    </div>
                </div>
                <div v-if="cleaningReport.nbItems > 0">
                    <div class="bg-white rounded-10 p-3 mx-3 mt-3 position-relative">
                        <h5><t blueprintSidebar.crossingTitle /></h5>
                        <span><t blueprintSidebar.crossingText /></span>
                        <div class="error-detect intersection" v-if="cleaningReport.quickAnalysis && !cleaningReport.quickAnalysis.pass"><t blueprintSidebar.tooManyCrossing /></div>
                        <div class="error-detect intersection" v-if="cleaningReport.quickAnalysis && cleaningReport.quickAnalysis.pass && cleaningReport.crossings && cleaningReport.crossings.count > 0">x{{cleaningReport.crossings.count}}</div>
                        <div class="error-detect intersection" v-if="cleaningReport.quickAnalysis && cleaningReport.quickAnalysis.pass && (!cleaningReport.crossings || cleaningReport.crossings.count == 0)"><t blueprintSidebar.none /></div>
                    </div>

                    <div class="bg-white rounded-10 p-3 mx-3 mt-3 position-relative">
                        <h5><t blueprintSidebar.openPathTitle /></h5>
                        <span><t blueprintSidebar.openPathText /></span>
                        <div class="error-detect open" v-if="cleaningReport.quickAnalysis && !cleaningReport.quickAnalysis.pass"><t blueprintSidebar.tooManyOpenPath /></div>
                        <div class="error-detect open" v-if="cleaningReport.quickAnalysis && cleaningReport.quickAnalysis.pass && cleaningReport.openPaths && cleaningReport.openPaths.count > 0">x{{cleaningReport.openPaths.count}}</div>
                        <div class="error-detect open" v-if="cleaningReport.quickAnalysis && cleaningReport.quickAnalysis.pass && (!cleaningReport.openPaths || cleaningReport.openPaths.count == 0)"><t blueprintSidebar.none /></div>
                    </div>
                </div>
            </div>
            
            <div>
                <div class="mb-3" v-if="activeStep == 0 && cleaningReport.nbItems > 0">
                    <div class="bg-rose text-white w-100 d-flex align-items-center py-2 border-0 rounded-top-10 mt-4 px-2">
                        <b-icon icon="file-earmark-break-fill" font-scale="1.3" />
                        <span class="font-weight-bold p-0 ml-2"><t blueprintSidebar.dxfInfoTitle /></span>
                    </div>
                    <div class="bg-gris-pro rounded-bottom-10 px-2 py-3">
                        <p class="text-dark line-height p-0 mb-0 ml-2"><t blueprintSidebar.dxfInfo /></p>
                    </div>
                </div>

                <div class="bg-gris-pro p-3 rounded-10">
                    <div class="btn btn-jaune d-block rounded-10 p-0">
                        <span class="font-weight-bold text-dark" @click="onContactReturn()"><t blueprintSidebar.contactUs /></span>
                    </div>
                    <div class="btn btn-white d-block rounded-10 p-0 mt-2">
                        <span class="font-weight-bold close-iframe" @click="onDeckReturn()"><t blueprintSidebar.returnDeck /></span>
                    </div>
                </div>
            </div>
        </div>

        <div class="mb-1 d-flex flex-column justify-content-between h-100" v-if="activeStep == 1">
            <div class="bg-gris-pro rounded-10 pb-3">
                <span class="bg-rose rounded-top-10 d-block py-2 text-center font-weight-bold text-white"><t blueprintSidebar.dimensions /></span>

                <p class="pt-3 px-3"><t blueprintSidebar.textDimensions /></p>

                <div class="p-3 bg-white rounded-10 mx-3">
                    <span class="font-weight-bold"><t blueprintSidebar.width /></span>
                    <b-input-group class="border-gris-pro rounded-10" v-bind:class="{ 'error-border': errorWidth }">
                        <b-form-input class="rounded-10 border-0" type="number" v-model="width" no-wheel @update="widthToConfirm = true" @click="textFocus" @blur="textBlur"></b-form-input>
                        <b-input-group-append v-if="widthToConfirm">
                            <b-button class="btn-jaune font-weight-bold text-white px-2 rounded-right-10" variant="link" @click="applyWidth()"><t blueprintSidebar.ok /></b-button>
                        </b-input-group-append>
                    </b-input-group>
                    <transition-group name="bounce">
                        <div class="fly-over-setting my-2 mx-1 position-relative" v-if="errorWidth == true" key="errorWidth">
                            <div class="bg-gris-pro rounded-10 px-3 py-2 text-left">
                                <p class="text-dark mb-0 line-height">
                                    <t blueprintSidebar.limitsDimensions /> {{this.maximalWidth}} mm
                                </p>
                            </div>
                        </div>
                    </transition-group>

                    <span class="font-weight-bold mt-2 d-block"><t blueprintSidebar.height /></span>
                    <b-input-group class="border-gris-pro rounded-10" v-bind:class="{ 'error-border': errorHeight }">
                        <b-form-input class="rounded-10 border-0" type="number" v-model="height" no-wheel @update="heightToConfirm = true" @click="textFocus" @blur="textBlur"></b-form-input>
                        <b-input-group-append v-if="heightToConfirm">
                            <b-button class="btn-jaune font-weight-bold text-white px-2 rounded-right-10" variant="link" @click="applyHeight()"><t blueprintSidebar.ok /></b-button>
                        </b-input-group-append>
                    </b-input-group>
                    <transition-group name="bounce">
                        <div class="fly-over-setting my-2 mx-1 position-relative" v-if="errorHeight == true" key="errorHeight">
                            <div class="bg-gris-pro rounded-10 px-3 py-2 text-left">
                                <p class="text-dark mb-0 line-height">
                                   <t blueprintSidebar.limitsDimensions /> {{this.maximalHeight}} mm
                                </p>
                            </div>
                        </div>
                    </transition-group>
                </div>
                <div id="validate-dimension" class="p-0 text-white d-block mt-3 mx-3 rounded-10" v-if="widthToConfirm == true || heightToConfirm == true">
                    <b-button v-if="isClean && !scaleProductSet" variant="link" class="text-white font-weight-bold btn-grey w-100"><span><t blueprintSidebar.validate /></span></b-button>
                </div>
                <div v-else class="p-0 text-white d-block mt-3 mx-3 rounded-10" @click="scaleProductSet = true, onDimensionsValidate()">
                    <b-button variant="link" class="text-white btn-vert font-weight-bold p-0 w-100">
                        <span v-if="spinner"><t blueprintSidebar.validate /></span>
                        <svg v-else id="spinner" width="30" height="42"><use xlink:href="/themes/johnsteel/assets/img/sprite.svg#fa-spinner"></use></svg>
                    </b-button>
                </div>
            </div>

            <div class="bg-gris-pro rounded-10 p-3">
                <div class="btn btn-jaune d-block rounded-10 p-0">
                    <a href="https://www.john-steel.com/fr/nous-contacter" target="_blank" class="font-weight-bold text-dark"><span><t blueprintSidebar.contactUs /></span></a>
                </div>
                <div class="btn btn-white d-block rounded-10 p-0 mt-2">
                    <span class="font-weight-bold close-iframe" @click="onDeckReturn()"><t blueprintSidebar.returnDeck /></span>
                </div>
            </div>
        </div>

        <div class="h-100 mb-1 d-flex flex-column justify-content-between" v-if="activeStep == 2">
            <div>
                <div class="bg-gris-pro rounded-10">
                    <span class="bg-rose rounded-top-10 d-block py-2 text-center font-weight-bold text-white" @click="activeStep = 2"><t blueprintSidebar.optimizations /></span>
                    <p class="bg-white rounded-10 p-3 m-3 d-inline-block">
                        <t blueprintSidebar.textOptimizations />
                    </p>
                    <div class="px-3 pb-3">
                        <div class="btn btn-jaune p-0 w-100 rounded-10">
                            <a href="https://www.john-steel.com/fr/nous-contacter" target="_blank" class="font-weight-bold text-dark"><span><t blueprintSidebar.contactUs /></span></a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bg-gris-pro rounded-10 p-3 mt-3">
                <div @click="onOptimisationAccept()" class="validate btn mb-2 btn-vert w-100 rounded-10">
                    <span><t class="font-weight-bold" blueprintSidebar.accept /></span>
                </div>
                <div @click="onOptimisationRefuse()" class="deny btn btn-white w-100 rounded-10 p-0">
                    <span><t class="font-weight-bold" blueprintSidebar.refuse /></span>
                </div>
            </div>
        </div>

        <div class="mb-1 d-flex flex-column justify-content-between" v-if="activeStep == 3">
            <materials-choice />
            <br/>
            <div v-for="piece in this.pieces" v-bind:key="piece.name" class="border-0 rounded-0 bg-transparent px-0 pt-1 mx-1"  :class="{'sizeInvalid' : piece.validSize == false}">
                <div v-if="piece.isCopyOf == null" class="bg-white rounded-10 d-flex">
                    <div class="d-flex align-items-center col-9 p-0 my-1">
                        <div v-if="piece.svg" vertical-align="center" v-html="piece.svg" class="thumbnail h-100 bg-gris-pro p-2 ml-1 rounded-10 d-flex align-items-center"></div>
                        <div class="pl-2 col-10">
                            <span class="font-weight-bold text-dark text-capitalize">
                                {{piece.name}}
                            </span>
                            <span class="d-flex">
                                <span class="small font-weight-bold">
                                    <div class="d-flex align-items-center">
                                        <b-icon icon="crop" font-scale="1" />
                                        <span v-bind:class="{'text-danger': !piece.validSize}" class="ml-1">{{Math.ceil(piece.width)}} <t addToCart.mm /> x {{Math.ceil(piece.height)}} <t addToCart.mm /></span>
                                    </div>
                                    <div class="d-flex">
                                        <img :src="require( '@/assets/img/poids.svg')" height="15px">
                                        <span class="ml-1">{{Math.ceil(piece.weight)}} <t addToCart.kg /></span>
                                    </div>
                                    <b-icon icon="cloud-download" font-scale="1" class="ml-1 cursor-pointer" @click.prevent.stop="exportToDxf(piece.name)" />
                                </span>
                            </span>
                        </div>
                    </div>
                    <div class="col-3 p-0 d-flex flex-column justify-content-between">
                        <div>
                            <span class="float-right qty text-white font-weight-bold px-2 bg-jaune bg-gris-pro">x {{piece.copies.length + 1}}</span>
                        </div>
                        <span class="d-block text-dark font-weight-bold price text-right pr-2 pb-1">{{piece.price ? piece.price.toFixed(2) : "0.00"}} €</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import { paper, Point } from 'paper';
import { BButton, BIconCircleFill, BIcon, BIconSlashCircle, BIconstack, BIconSquareFill, BIconBinoculars, BIconCheck, BCollapse, BCard, BCardHeader, BCardBody, VBToggle, BFormInput, BInputGroup, BInputGroupAppend, BCardText, BFormSelect, BBadge, BRow, BCol, BContainer, BIconCloudDownload, BMedia, BMediaAside, BMediaBody, BFormGroup, BFormRadioGroup, BIconFileEarmarkBreakFill } from 'bootstrap-vue';
import PathUtils from '@/services/PathUtils';
import PainterService from '@/services/PainterService';
import store from '../../store';
import { models } from 'feathers-vuex';
import { ImportedShape } from '../../shapes/ImportedShape';
import { ImportedCircle } from '../../shapes/ImportedCircle';
import { ImportedEllipse } from '../../shapes/ImportedEllipse';
import VueSlider from "vue-slider-component";
import { EventBus } from '@/services/EventBus';
import MaterialsChoice from './MaterialsChoice.vue';
import ConversionService  from '../../services/ConversionService';
import FileSaver from 'file-saver';

/* eslint-disable vue/no-unused-components */
export default {
    components: { BButton, BIcon, BIconstack, BIconCircleFill, BIconSlashCircle, BIconSquareFill, BIconBinoculars, BIconCheck, BCollapse, BCard, BCardHeader, BCardBody, BFormInput, BInputGroup, BInputGroupAppend, BCardText, BFormSelect, BBadge, BRow, BCol, VueSlider, BContainer, BIconCloudDownload, BMedia, BMediaAside, BMediaBody, BFormGroup, BFormRadioGroup, MaterialsChoice, BIconFileEarmarkBreakFill },
    directives: { 'b-toggle': VBToggle },
    data() {
        return {
            activeStep: null,
            width: 0,
            height: 0,
            widthToConfirm: false,
            heightToConfirm: false,
            selectedProduct: null,
            selectedThickness: null,
            products: [],
            thicknesses: [],
            cuttingparams: [],
            dataLoaded: false,
            scaleProductSet: false,
            s1: false,
            skipOptimisation: false,
            steps: [
                { text: 'Nettoyage', value: 0 },
                { text: 'Taille', value: 1 },
                { text: 'Optimisations', value: 2 },
                { text: 'Matières', value: 3 },
            ],
            errorWidth: false,
            errorHeight: false,
            maximalHeight : 0,
            maximalWidth: 0,
            spinner: true,
            language: window.obelix.language,
        }
    },
    computed: {
        ...mapGetters([
            'mode',
            'cleaningReport',
            'zoom',
            'availableColors',
            'selectedColors',
            'displayErrors',
            'pieces',
            'sizeItemId',
            'standaloneMode',
            'cuttingOptions',
            'crossingPoints'
        ]),
        colors: function() {
            let available = this.availableColors.split(";");
            let selected = this.selectedColors.split(";");
            return available.map(color => {
                return {
                    rgb: color,
                    selected: selected.indexOf(color) > -1
                }
            });
        },
        isClean: function () {
            return this.cleaningReport.quickAnalysis && this.cleaningReport.quickAnalysis.pass
                && this.cleaningReport.openPaths && this.cleaningReport.openPaths.count == 0
                && this.cleaningReport.crossings && this.cleaningReport.crossings.count == 0;
        },
        thicknessesForProduct: function() {
            let thicknessIds = this.cuttingparams
                .filter(p => p.product == this.selectedProduct)
                .map(p => p.thickness);

            return this.thicknesses.filter(t => thicknessIds.includes(t.psid) );
        },
        uniquePieces: function() {
            return this.pieces ? this.pieces.filter(p => !p.isCopyOf) : []
        }
    },
    async mounted() {
        await this.refreshProducts();
        await this.refreshThicknesses();
        await this.refreshCuttingParams();
        if (window.obelix.onMounted) window.obelix.onMounted(this);
        EventBus.$on('blueprintUpdated', () => this.skipOptimisation = false);

        this.dataLoaded = false;
        this.selectedProduct = this.$store.getters.productPsid;
        this.selectedThickness = this.$store.getters.thicknessPsid;
        this.$nextTick(() => {
            this.dataLoaded = true;
            PathUtils.autoZoomOn(paper.project.layers.import.getItems());
            if (this.standaloneMode){
                if(this.selectedProduct == null){
                    this.selectedProduct = this.products[0].psid;
                }
                this.activeStep = 0;
                if(!window.obelix.viewer)this.selectTool('blueprintcleaner');
                PainterService.showImport();
                PainterService.showBlueprint();
            }
        });
    },
    watch: {
        selectedProduct: async function() {
            if (this.thicknessesForProduct.length < 1) return;
            if (this.thicknessesForProduct.some(t => t.psid == this.selectedThickness)) {
                if (this.dataLoaded) this.$store.dispatch('setArticle', {product: this.selectedProduct, thickness: this.selectedThickness});
            }
            else
            {
                this.selectedThickness = this.thicknessesForProduct[0].psid;
            }
            this.scaleProductSet = false;

        },

        sizeItemId: function(newVal) {
            if (newVal) {
                let item = paper.project.layers.blueprint.getItem({ id: this.sizeItemId });
                if (!item) return;

                this.width = Math.round(item.bounds.width * 100) / 100;
                this.height = Math.round(item.bounds.height * 100) / 100;
            }
        },

        selectedThickness: async function() {
            if (!this.dataLoaded) return;
            this.$store.dispatch('setArticle', {product: this.selectedProduct, thickness: this.selectedThickness});
            this.scaleProductSet = false;
        },
        activeStep: async function(newVal, oldVal) {
            if (window.obelix.onStepReady) window.obelix.onStepReady();
            if (oldVal == newVal) return;

            this.activeStep = newVal;

            if (oldVal == 0) {
                PainterService.hideImport();
            }
            if (oldVal == 1) {
                store.dispatch('setLoadingStep', this.$t('blueprintSidebar.pleaseWait'));
                await PainterService.hideItemSize();
            }
            if (oldVal == 2 || oldVal == 3) {
                store.dispatch('setLoadingStep', this.$t('blueprintSidebar.planMode'));
                this.$store.dispatch('setOptimisationMode',false);
                paper.project.layers.view.removeChildren();
                paper.project.layers.selectable.removeChildren();
            }

            if (newVal == 0) {
                store.dispatch('setLoadingStep', this.$t('blueprintSidebar.prepareToClean'));
               if(!window.obelix.viewer)this.selectTool('blueprintcleaner');
                PainterService.showImport();
                PainterService.showBlueprint();
            }
            if (newVal == 1) {
                paper.project.layers.view.removeChildren();
                paper.project.layers.selectable.removeChildren();
                await this.selectLargestItem();
                this.selectTool('itemsize');
                PainterService.showBlueprint();
                PainterService.displayItemSize();
            }
            if (newVal == 2 || newVal == 3) {
                this.selectTool('selecter');
                this.$store.dispatch('setOptimisationMode',true);
                store.dispatch('setLoadingStep', this.$t('blueprintSidebar.optimizations'));
                if (this.skipOptimisation) {
                    store.dispatch('repaintComposition');
                }
                else {
                    await this.blueprintToShapes();
                }
                await PainterService.hideBlueprint();
            }
            store.dispatch('setLoadingStep', '');
        }

    },
    methods: {
        ...mapActions([
            'textFocus',
            'textBlur'
        ]),
        async switchOpenPaths() {
            await store.dispatch('displayErrors', this.displayErrors == 'openPaths' ? '' : 'openPaths');
            PainterService.repaint();
        },
        async showCrossings() {
            await store.dispatch('displayErrors', this.displayErrors == 'crossings' ? '' : 'crossings');
            PainterService.repaint();
        },

        async selectLargestItem() {
            if (this.sizeItemId) {
                let item = paper.project.layers.blueprint.getItem({ id: this.sizeItemId });
                if (!item) {
                    await store.dispatch('setSizeItemId', null);
                }
            }

            if (!this.sizeItemId) {
                let items = paper.project.layers.blueprint.getItems()
                    .sort((a, b) => b.length - a.length);

                if (items.length > 0) await store.dispatch('setSizeItemId', items[0].id);
            }
        },

        async blueprintToShapes() {
            let items = paper.project.layers.blueprint.getItems();
            paper.project.layers.view.removeChildren();

            let importedShapes = [];
            items.forEach(async item => {
                if (item.className == 'Shape') {
                    switch (item.type) {
                        case 'circle':
                            importedShapes.push(new ImportedCircle(item));
                            break;
                        case 'ellipse':
                            importedShapes.push(new ImportedEllipse(item));
                            break;
                        default:
                            console.error("unknown shape type", item.type);
                            item.strokeColor = '#00FF00';
                            item.strokeWidth = 5;
                    }

                } else {
                    let shape = new ImportedShape();
                    await shape.init(item);
                    importedShapes.push(shape);
                }
            });
            paper.project.layers.temp.removeChildren();
            await store.dispatch('updateShapes', importedShapes);
            this.skipOptimisation = true;
        },

        async refreshProducts() {
            let blockSize = 20;
            let response = await models.api.Product.find({query: {$limit: blockSize}});
            this.products = response.data;
            let steps = response.total / blockSize;

            for (let i = 1; i < steps; i++) {
                response = await models.api.Product.find({query: {$limit: blockSize, $skip: i * blockSize}});
                this.products = this.products.concat(response.data);
            }
            this.products.sort((a, b) => a.name[this.language].localeCompare(b.name[this.language]));
        },

        async refreshThicknesses() {
            let blockSize = 50;
            let response = await models.api.Thickness.find({query: {$limit: blockSize}});
            this.thicknesses = response.data;
            let steps = response.total / blockSize;

            for (let i = 1; i < steps; i++) {
                response = await models.api.Thickness.find({query: {$limit: blockSize, $skip: i * blockSize}});
                this.thicknesses = this.thicknesses.concat(response.data);
            }
            this.thicknesses.sort((a, b) => a.thickness - b.thickness);
            this.thicknesses.forEach(t => t.name = t.thickness + ' mm');
        },

        async refreshCuttingParams() {
            let blockSize = 20;
            let response = await models.api.CuttingParams.find({query: {$limit: blockSize}});
            this.cuttingparams = response.data;
            let steps = response.total / blockSize;

            for (let i = 1; i < steps; i++) {
                response = await models.api.CuttingParams.find({query: {$limit: blockSize, $skip: i * blockSize}});
                this.cuttingparams = this.cuttingparams.concat(response.data);
            }

            let activeProducts = new Set(this.cuttingparams
                .filter(cp => cp.cuttingOptions.active == 1)
                .map(cp => cp.product));

            this.products = this.products.filter(p => activeProducts.has(p.psid));
        },

        async applyWidth() {
            paper.project.layers.view.removeChildren();
            paper.project.layers.selectable.removeChildren();
            this.widthToConfirm = false;
            this.heightToConfirm = false;

            let item = paper.project.layers.blueprint.getItem({ id: this.sizeItemId });
            if (!item) return;
            EventBus.$emit('blueprintUpdated');

            let ratio = this.width / item.bounds.width;
            this.height = Math.round(this.height * 100 * ratio) / 100;
            let origin = new Point(0, 0);
            paper.project.layers.import.getItems().forEach(i => i.scale(ratio, origin));
            paper.project.layers.blueprint.getItems().forEach(i => i.scale(ratio, origin));
            this.detectSizeError();
            PathUtils.autoZoomOn(paper.project.layers.blueprint.getItems());
            PainterService.displayItemSize();

            this.scaleProductSet = false;
        },

        async applyHeight() {
            paper.project.layers.view.removeChildren();
            paper.project.layers.selectable.removeChildren();
            this.widthToConfirm = false;
            this.heightToConfirm = false;

            let item = paper.project.layers.blueprint.getItem({ id: this.sizeItemId });
            if (!item) return;
            EventBus.$emit('blueprintUpdated');

            let ratio = this.height / item.bounds.height;
            this.width = Math.round(this.width * 100 * ratio) / 100;
            let origin = new Point(0, 0);
            paper.project.layers.import.getItems().forEach(i => i.scale(ratio, origin));
            paper.project.layers.blueprint.getItems().forEach(i => i.scale(ratio, origin));
            this.detectSizeError();
            PathUtils.autoZoomOn(paper.project.layers.blueprint.getItems());
            PainterService.displayItemSize();

            this.scaleProductSet = false;
        },
        detectSizeError(){
            this.pathErrorWidth =  paper.project.layers.blueprint.getItems({class: 'Path'}).find(i => {
                if (i.bounds.width < i.bounds.height && this.cuttingOptions.allowMaterialRotation == 1) {
                    this.maximalWidth = this.cuttingOptions.maximalHeight
                    return i.bounds.width > this.cuttingOptions.maximalHeight
                } else {
                    this.maximalWidth = this.cuttingOptions.maximalWidth
                    return i.bounds.width > this.cuttingOptions.maximalWidth
                }
            });
            if(typeof(this.pathErrorWidth) != 'undefined'){
                this.pathErrorHeight = paper.project.layers.blueprint.getItem({id: this.pathErrorWidth.id});
                if (this.pathErrorHeight.bounds.height > this.pathErrorHeight.bounds.width && this.cuttingOptions.allowMaterialRotation == 1) {
                    this.maximalHeight = this.cuttingOptions.maximalWidth
                } else {
                    this.maximalHeight = this.cuttingOptions.maximalHeight
                }
            } else{
                this.pathErrorHeight =  paper.project.layers.blueprint.getItems({class: 'Path'}).find(i => {
                    if (i.bounds.height > i.bounds.width && this.cuttingOptions.allowMaterialRotation == 1) {
                        this.maximalHeight = this.cuttingOptions.maximalWidth
                        return i.bounds.height > this.cuttingOptions.maximalWidth
                    } else {
                        this.maximalHeight = this.cuttingOptions.maximalHeight
                        return i.bounds.height > this.cuttingOptions.maximalHeight
                    }
                });
            }
            if(typeof(this.pathErrorWidth) != 'undefined'){
                store.dispatch('setSizeItemId', this.pathErrorWidth.id);
                this.widthToConfirm = true;
                this.errorWidth = true;
            }else{
                this.errorWidth = false;
            }
            if(typeof(this.pathErrorHeight) != 'undefined'){
                if( this.pathErrorHeight.bounds.height > this.maximalHeight){
                    this.heightToConfirm = true;
                    this.errorHeight = true;
                }
                if(typeof(this.pathErrorWidth) == "undefined"){
                    store.dispatch('setSizeItemId', this.pathErrorHeight.id);
                }
            }else{
                this.errorHeight = false;
            }
        },
        selectTool(tool) {
            this.$store.dispatch('setWhiteboardTool', tool);
        },

        getBounds() {
            let minTop = 99999999, maxBottom = 0, minLeft = 9999999, maxRight = 0;
            paper.project.layers.blueprint.getItems().forEach(item => {
                let bounds = item.bounds;
                if (bounds.area == 0) return;
                if (bounds.top < minTop) minTop = bounds.top;
                if (bounds.bottom > maxBottom) maxBottom = bounds.bottom;
                if (bounds.left < minLeft) minLeft = bounds.left;
                if (bounds.right > maxRight) maxRight = bounds.right;
            });
            return {minTop, maxBottom, minLeft, maxRight};
        },

        async switchColor(rgb) {
            let selected = this.selectedColors.split(";");
            let available = this.availableColors.split(";");

            if (selected.length == available.length) {
                selected = [rgb];
            } else {
                if (selected.indexOf(rgb) < 0) {
                    selected.push(rgb);
                } else {
                    selected = selected.filter(c => c != rgb);
                    if (selected.length == 0) selected = available;
                }
            }


            let itemsToIgnore = paper.project.layers.import.getItems({
                strokeColor: color => color && selected.indexOf(color.toCSS(true)) < 0,
                name: 'selected'
            })
            itemsToIgnore.forEach(item => {
                item.name = 'ignored';
            });

            store.dispatch('setSelectedColors', selected.join(";"));
            await PathUtils.updateBlueprint(paper.project.layers.import, paper.project.layers.blueprint);
        },
        async onOptimisationRefuse(){
            if(window.obelix.onOptimisationRefuse) window.obelix.onOptimisationRefuse();
        },
        async onOptimisationAccept(){
            if(window.obelix.onOptimisationAccept) window.obelix.onOptimisationAccept();
        },
        async onDimensionsValidate(){
            this.spinner = false;
            await this.blueprintToShapes();
            if(window.obelix.onDimensionsValidate) window.obelix.onDimensionsValidate();
            this.spinner = true;
        },
        async onDeckReturn(){
            if(window.obelix.onDeckReturn) window.obelix.onDeckReturn();
        },
         async exportToDxf(pieceId) {
            let compositionId = this.$store.getters.compositionId;
            let dxfData = await ConversionService.exportToDxf(pieceId,compositionId);
            if (dxfData == null) {
                Log.warn("Donnees DXF vides apres conversion");
                return;
            }
            var blob = new Blob([dxfData], {type: "image/vnd.dxf;charset=utf-8"});
            FileSaver.saveAs(blob, compositionId+pieceId+".dxf");
        },
        async onContactReturn(){
            if(window.obelix.onContactReturn) window.obelix.onContactReturn();
        }
    }
};

</script>

<style lang="scss">
    @import './../../assets/scss/_variables.scss';

    .thumbnail {
        svg {
            width: 7em;
            height: 4em;
            path {
                vector-effect: non-scaling-stroke;
            }
        }
    }

    #validate-dimension {
        &.btn-grey {
            opacity: .5;
            cursor: not-allowed;
        }
    }

    .error-detect {
        position: absolute;
        right: 0;
        top: 0;
        padding: 5px 10px;
        font-weight: bold;
        font-size: 1.1rem;
        border-radius: 0 10px 0 10px;
        color: white;

        &.intersection {
            background: #EF3340;
        }

        &.open {
            background: #F5D600;
        }
    }

    .error-border{
        border-color: #ffb400;
        .btn{
            border-radius: 5px;
        }
    }

    #spinner{
        animation-name: rotateIn;
        animation-duration: 2s;
        animation-iteration-count: infinite;
        fill: white;
    }

    @keyframes rotateIn {
       from{-webkit-transform:rotate(-200deg);transform:rotate(-200deg);opacity:0}
        to{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}
    }

    #btn-radios-1 .btn span {
        display: block;
        padding: .20rem .25rem;
    }
        
</style>
